import axios from 'axios';
import assign from 'object-assign';

axios.defaults.timeout = 30000;
axios.defaults.baseURL = process.env.API_ROOT; // 域名
if (typeof window !== 'undefined') {
  axios.interceptors.request.use(function (config) {
    let user = {};
    // xlang = 'en';

    user = JSON.parse(sessionStorage.getItem('user') || null);
    // xlang = localStorage.getItem('xlang') || 'en';
    // xlang = xlang.substr(0, 2);
    let customHeader = {
      // for ie no-cache
      Expires: -1,
      pragma: 'no-cache',
      'Cache-Control': 'must-revalidate, private'
      // Pragma: 'no-cache'
      // 'Access-Control-Allow-Origin': '*'
      // 'x-env-lang': xlang
    };
    if (user && !config.headers.Authorization) {
      customHeader['Authorization'] = user.token;
    }
    config.headers = assign({}, config.headers, customHeader);
    return config;
  }, function (error) {
    console.log(error);
    // Do something with request error
    return Promise.reject(error);
  });
  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
      const { response } = error;
      if (!response) {
        error = { response: { status: 504 } };
      } 

      switch (response.status) { 
        case 401:
          console.log('登入逾時');
          break;
        case 400:
          console.log('參數格式錯誤');
          break;
        case 504:
          console.log('連接到服務器失敗');
          break;
        default: //500
          console.log(`連接錯誤: ${response.statusText}`);
          break;
      }

    return Promise.reject(error);
  });
}
export default axios;
